export const MASTER_FEATURE_LIST_SUCCESS = 'MASTER_FEATURE_LIST_SUCCESS';
export const MASTER_TAG_LIST_SUCCESS = 'MASTER_TAG_LIST_SUCCESS';
